import { call, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { fetchMt5SReportChart } from '../../api/api';
import {
  loadReport5SChartSuccess,
  loadReport5SChartFailure,
} from './actions';
import { LoadChartRequestAction } from '../../types/report5SAudits';

export function* loadReport5SChartSaga(action: LoadChartRequestAction) {
  const { filters } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(fetchMt5SReportChart, filters);
    if (response.data?.success) {
      yield put(loadReport5SChartSuccess(response.data.data));
    } else {
      yield put(loadReport5SChartFailure(response.data?.error || 'Не удалось загрузить данные графика 5S'));
    }
  } catch (error) {
    const errorMessage = (error as any)?.message || 'Ошибка загрузки данных графика 5S';
    yield put(loadReport5SChartFailure(errorMessage));
  }
}
